import styled from "styled-components";
import {Row, Select, Button, Drawer} from "antd";

export const SelectField = styled(Select)`
    width: 100%;
`;

export const FilterRowContainer = styled.div`
    position: absolute;
    z-index: 1000;
    width: 100%;
    pointer-events: none;

    & > * {
        pointer-events: auto;
    }
`;

export const FilterRow = styled(Row)`
    margin: 0 auto !important;
    padding: 10px 20px;
    background: #ffffffbd;

    &.filter-row-customer {
        display: flex;
        justify-content: flex-end;
    }
`;

export const StatisticsContainer = styled.div`
    position: absolute;
    background: #ffffffe3;
    z-index: 3;
    bottom: 0px;
    right: 0px;
    padding: 15px;
    border-radius: 4px;
`;

export const LeftCornerContainer = styled.div`
    position: absolute;
    background: #ffffffe3;
    z-index: 3;
    bottom: 0px;
    left: 0px;
    padding: 5px;
    border-radius: 4px;
`;

export const RightCornerContainer = styled.div`
    position: absolute;
    background: #ffffffe3;
    z-index: 3;
    bottom: 0px;
    left: 0px;
    padding: 5px;
    border-radius: 4px;
`;

export const LeftTopCornerContainer = styled.div`
    background: #ffffffe3;
    padding: 5px;
    border-radius: 4px;
    display: inline-block;
    pointer-events: auto;
    width: fit-content;
`;

export const RightTopCornerContainer = styled.div`
    background: #ffffffe3;
    padding: 5px;
    border-radius: 4px;
    display: ${props => (props.isMobile ? "flex" : "inline-block")};
    position: absolute;
    right: 0;
    margin-top: ${props => (props.isMobile ? "30px" : "0")};
    &.right-top-corner-customer {
        padding: 1px 5px;
        top: 10px;
        right: 50px;
        z-index: 10;
    }
`;

export const SwitchContainer = styled.div`
    padding: 5px;
    &:after {
        content: "${props => props.label}";
        margin-left: 6px;
        font-size: 12px;
    }
`;

export const StatusColor = styled.div`
    background-color: ${props => props.color};
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin: auto 5px auto 0px;
`;

export const MapContainer = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    overflow: auto;
`;

export const TypeIcon = styled.div`
    margin-right: 5px;
`;

export const MobileFilterButton = styled(Button)`
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    background-color: white;
    color: black;
    width: 120px;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    width: 100px;

    &.mobile-filter-button-customer {
        position: absolute;
        top: 10px;
        right: 50px;
        z-index: 1000;
    }
`;

export const MobileMenuButton = styled(Button)`
    position: absolute;
    top: 10px;
    left: 10px;
    width: 120px;
    z-index: 10;
    background-color: white;
    color: black;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    width: 100px;

    &.mobile-menu-button-customer {
        position: absolute;
        top: 10px;
        left: 10px;
        z-index: 1000;
    }
`;

export const DensityButton = styled(Button)`
    position: absolute;
    top: 50px;
    right: 10px;
    z-index: 10;
    background-color: white;
    color: black;
    border-radius: 4px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    width: 100px;
`;
